/** Shared monochrome ink tokens for landing sections */

export function monoInk(isDark: boolean) {
  return {
    ink: isDark ? "#f5f5f5" : "#171717",
    muted: isDark ? "#8a8a8a" : "#737373",
    soft: isDark ? "#a3a3a3" : "#a3a3a3",
    hairline: isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)",
    card: isDark ? "rgba(255,255,255,0.05)" : "#ffffff",
    chip: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
    /** On always-dark canvases (certs / contact) */
    onDarkInk: "#f5f5f5",
    onDarkMuted: "#8a8a8a",
    onDarkHairline: "rgba(255,255,255,0.12)",
    onDarkCard: "rgba(255,255,255,0.06)",
  };
}
